import { render, staticRenderFns } from "./MetalAvgPrcCountRpt.vue?vue&type=template&id=530df347&scoped=true&"
import script from "./MetalAvgPrcCountRpt.vue?vue&type=script&lang=js&"
export * from "./MetalAvgPrcCountRpt.vue?vue&type=script&lang=js&"
import style0 from "./MetalAvgPrcCountRpt.vue?vue&type=style&index=0&id=530df347&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530df347",
  null
  
)

export default component.exports